<div class="flex flex-col w-full h-full">
  <label class="text-sm text-ts-input-label leading-5" *ngIf="label">{{ label }}</label>

  <div
    class="ts-datepicker"
    [ngClass]="{
      'rounded-lg': roundedBorders,
    }"
  >
    <input
      tsDateMask
      class="w-full"
      [min]="min"
      [max]="max"
      type="text"
      [placeholder]="placeholder || 'MM/DD/YYYY'"
      [formControl]="control"
      [matDatepicker]="picker"
    />
    <mat-datepicker-toggle
      [ngStyle]="{ transform: 'translateX(12px)' }"
      matDatepickerToggleIcon="caret"
      matSuffix
      disableRipple="true"
      [for]="picker"
    >
      <mat-icon matDatepickerToggleIcon>calendar_month</mat-icon>
    </mat-datepicker-toggle>

    <mat-datepicker
      [startView]="mode"
      yPosition="below"
      #picker
      (monthSelected)="setMonthAndYear($event, picker)"
    ></mat-datepicker>
  </div>

  <p class="text-xs text-gray-500 mt-1" *ngIf="hint">{{ hint }}</p>

  <div *ngIf="control?.errors && errorMessages">
    <ng-container *ngFor="let error of control?.errors | keyvalue">
      <p class="mb-1 text-xs text-danger" *ngIf="errorMessages[error.key]?.length > 0">
        {{ errorMessages[error.key] }}
      </p>
    </ng-container>
  </div>
</div>
